import type { TranslationQuoteView } from '@/features/ai/useTranslationQuote'
import { MenuButton } from './MenuButton'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  quote: TranslationQuoteView
  /** Смета не приехала И больше не летит. Признак считает владелец кнопок —
   *  теми же выражениями, что гасят запуск (манера `DrawImagesBody`). */
  quoteFailed: boolean
}

/**
 * Что именно произойдёт по клику и во сколько это обойдётся. Мёртвые состояния
 * кнопки объясняются РАЗНЫМИ текстами, а не общим «= 0»: смета не доехала здесь,
 * «переводить нечего» — подсказкой на самой кнопке. Молчаливый ноль читался бы как «перевод бесплатный», а
 * при упавшем `GET /quote` это состояние ещё и вечное — отсюда повтор запроса
 * (та же манера, что у `DrawImagesBody`).
 */
export const TranslatePlan = ({ quote, quoteFailed }: Props) => {
  const m = useMessages(messages)

  if (quoteFailed) {
    return (
      <div className="space-y-2 rounded-xl border border-warning/30 bg-warning/10 p-3 text-xs text-foreground">
        <p>{m.quoteFailed}</p>
        {/* Пункт меню, а не кнопка: иначе с клавиатуры до повтора не дойти. */}
        <MenuButton className="w-auto" onSelect={quote.refetch}>
          {m.refetchQuote}
        </MenuButton>
      </div>
    )
  }
  if (quote.pendingUnits === undefined) {
    return <p className="text-xs text-muted-foreground">{m.quoteLoading}</p>
  }
  return null
}
